import React from 'react';
import { Route } from 'react-router-dom';
import ErrorBoundary from './Generic/ErrorBoundaries';
import Notifications from './Notifications';
import OneHeader from './OneHeader';
import ClubBarBanner from './ClubBarBanner';
import RouteScrollToTop from 'Client/components/RouteScrollToTop';
import { RouterProvider } from 'Client/hooks/useRouter';
import { UserTrackingProvider } from 'Client/hooks/flags/useUserTracking';
import { isNativeAppPage as checkIsNativeAppPage } from 'Client/hooks/UrlManager/pageTypeService';

interface Props {
    host?: string;
}

const AppHeader = ({ host = '' }: Props) => {
    return (
        <ErrorBoundary boundaryName="Header" fallbackComponent={null}>
            <Route>
                {routerProps => {
                    const isNativeAppPage = checkIsNativeAppPage(routerProps.location.pathname);

                    return (
                        <RouterProvider
                            value={{
                                ...routerProps,
                                host,
                                disableClientsideNavigation: isNativeAppPage,
                                isAppWebviewPage: isNativeAppPage,
                            }}
                        >
                            <RouteScrollToTop />
                            <UserTrackingProvider>
                                <OneHeader detachedHeaderMode={false} />
                                <ClubBarBanner />
                                <Notifications />
                            </UserTrackingProvider>
                        </RouterProvider>
                    );
                }}
            </Route>
        </ErrorBoundary>
    );
};

export default AppHeader;
